{
  "title": "Projekte",
  "list_title": "Projekte",
  "no_projects": "Noch kein Projekt",
  "select_or_new": "Wähle rechts ein Projekt oder lege ein neues an.",
  "search_placeholder": "Suchen oder Tag…",
  "webhook": {
    "label": "Webhook-URL",
    "title": "Butler-Webhook",
    "description": "Externe Dienste lösen damit Butler-Flows dieses Projekts aus (Trigger „Webhook empfangen“).",
    "url": "URL",
    "secret": "Secret",
    "secret_missing": "kein Secret gesetzt",
    "show": "Anzeigen",
    "hide": "Verbergen",
    "rotate": "Neu erzeugen",
    "create": "Secret erzeugen",
    "rotate_confirm": "Neues Secret erzeugen? Aufrufe mit dem alten Secret werden sofort abgelehnt.",
    "rotate_failed": "Das Secret konnte nicht erneuert werden.",
    "copy_failed": "Konnte nicht in die Zwischenablage kopieren.",
    "header_hint": "Beim Aufruf als Header X-Webhook-Secret mitsenden."
  },
  "tags": {
    "label": "Tags",
    "add_placeholder": "Tag eingeben…"
  },
  "fields": {
    "members_count": "{{count}} Member",
    "members_label": "Members ({{count}})",
    "git_init": "git",
    "git_init_no": "no-git",
    "agent": "Project-Agent",
    "workspace": "Workspace",
    "agent_loading": "(geladen…)",
    "created_by": "{{date}} von {{user}}"
  },
  "delete_confirm": "Projekt \"{{name}}\" löschen?\n\nIncl. Project-Agent, Workspace und alle Sessions.",
  "members": {
    "no_members": "Keine Members",
    "remove_confirm": "'{{username}}' aus Projekt entfernen?",
    "select_user": "User auswählen…",
    "roles": {
      "read": "Lesen",
      "write": "Schreiben",
      "admin": "Admin"
    }
  },
  "tabs": {
    "overview": "Übersicht",
    "notes": "Notizen",
    "files": "Dateien",
    "sessions": "Sessions",
    "git": "Git",
    "servers": "Server",
    "stats": "Statistiken",
    "settings": "Einstellungen",
    "specialists": "Spezialisten",
    "audit": "Verlauf",
    "mounts": "Freigaben"
  },
  "specialists": {
    "description": "Welche Spezialisten darf der Projekt-Agent via ask_agent beauftragen?",
    "no_agentlink": "AgentLink ist nicht konfiguriert — Spezialisten können nicht aufgerufen werden.",
    "none": "Noch keine Spezialisten angelegt.",
    "save": "Speichern",
    "saved": "Gespeichert"
  },
  "notes": {
    "hint": "Markdown-Notizen, Briefing oder Kontext für dieses Projekt.",
    "agent_hint": "Beschreibung und Notizen bekommen die Agenten in Projekt-Sessions als Briefing mit (bis 4000 Zeichen).",
    "placeholder": "# Projekt-Briefing\n\nZiel, Kontext, Entscheidungen…"
  },
  "files": {
    "empty": "Workspace ist leer.",
    "close": "Schließen",
    "edit": "Bearbeiten",
    "save": "Speichern",
    "upload": "Upload",
    "delete": "Löschen",
    "delete_confirm": "\"{{name}}\" wirklich löschen?"
  },
  "overrides": {
    "title": "Tool-Einschränkungen",
    "mcp_label": "MCP-Server (Einschränkung)",
    "mcp_hint": "Leer = keine Einschränkung. Sonst nur diese MCP-Server der Agenten (kommagetrennte IDs). Fügt keine hinzu.",
    "plugins_label": "Plugins (Whitelist)",
    "plugins_hint": "Leer = keine Einschränkung. Sonst sind nur Tools dieser Plugins erlaubt (kommagetrennte Namen)."
  },
  "servers": {
    "empty": "Noch keine Server zugewiesen.",
    "count_one": "{{count}} Server",
    "count_other": "{{count}} Server",
    "add": "Server zuweisen",
    "add_title": "VM oder Container zuweisen",
    "none_available": "Keine freien VMs / Container — leg vorher welche unter /vms oder /containers an.",
    "unassign": "Aus Projekt entfernen",
    "unassign_confirm": "Server aus Projekt entfernen? (Server selbst bleibt erhalten)",
    "open_detail": "Detail öffnen"
  },
  "sessions": {
    "empty": "Noch keine Sessions in diesem Projekt.",
    "untitled": "(ohne Titel)"
  },
  "git": {
    "not_initialized": "Kein Git-Repository in diesem Workspace.",
    "recent_commits": "Letzte Commits",
    "no_remote": "Kein Remote konfiguriert.",
    "no_repos": "Noch keine Repos im Workspace.",
    "repos_count_one": "{{count}} Repo",
    "repos_count_other": "{{count}} Repos",
    "add_repo": "Repo hinzufügen",
    "add_repo_title": "Neues Repo zum Projekt hinzufügen",
    "repo_name": "Name (Subordner)",
    "repo_name_invalid": "Ungültig — nur a-z, 0-9, _ und -, max 50 Zeichen, nicht „_root\".",
    "remote_url": "Remote-URL",
    "token": "Access-Token",
    "token_set": "gespeichert",
    "save_settings": "Speichern",
    "clone_url": "Repository-URL",
    "branch_optional": "Branch (optional)",
    "init_empty": "Leer initialisieren",
    "clone": "Clonen",
    "delete_confirm": "Repo \"{{name}}\" aus diesem Projekt entfernen? Inklusive aller lokalen Änderungen.",
    "delete_repo": "Repo entfernen",
    "danger_zone_hint": "Dieser Schritt löscht den lokalen Workspace-Inhalt unwiderruflich.",
    "ahead": "ahead",
    "behind": "behind",
    "commit_message_placeholder": "Commit-Nachricht…",
    "commit": "Commit",
    "push": "Push",
    "pull": "Pull"
  },
  "stats": {
    "unavailable": "Statistiken nicht verfügbar.",
    "sessions": "Sessions",
    "sessions_active": "{{count}} aktiv",
    "messages": "Nachrichten",
    "tokens": "Tokens",
    "last_activity": "Letzte Aktivität"
  },
  "settings": {
    "danger_zone": "Gefahrenzone — diese Aktionen können nicht rückgängig gemacht werden.",
    "delete_project": "Projekt löschen"
  },
  "samba": {
    "title": "SMB-Share",
    "enable": "Aktiviert",
    "hint": "Login-Daten siehe System-Page → SMB-Shares. Samba muss am System eingerichtet sein.",
    "hint_inline": "Login funktioniert für alle aktivierten Projekte gleich. Samba muss am System eingerichtet sein (siehe System-Page).",
    "user_label": "User",
    "password_label": "Passwort",
    "copy": "Kopieren",
    "copied": "Kopiert!"
  },
  "audit": {
    "empty": "Noch keine Einträge.",
    "load_error": "Verlauf konnte nicht geladen werden.",
    "filter": {
      "all_actions": "Alle Aktionen",
      "user_placeholder": "User filtern…",
      "search": "Suchen"
    },
    "actions": {
      "project_updated": "Projekt geändert",
      "member_added": "Member hinzugefügt",
      "member_removed": "Member entfernt",
      "server_assigned": "Server zugewiesen",
      "server_unassigned": "Server entfernt",
      "member_role_changed": "Rolle geändert"
    }
  },
  "new_dialog": {
    "title": "Neues Projekt",
    "name_placeholder": "z.B. Website Relaunch",
    "model_label": "Modell für Project-Agent",
    "no_model": "(kein Modell konfiguriert)",
    "git_init": "Workspace mit `git init` initialisieren",
    "no_users": "(keine User)"
  },
  "mounts": {
    "empty": "Noch keine Freigabe zugewiesen.",
    "count_one": "{{count}} Freigabe",
    "count_other": "{{count}} Freigaben",
    "add": "Freigabe zuweisen",
    "add_title": "SMB-Freigabe zuweisen",
    "none_available": "Keine freien Freigaben — leg unten eine neue an.",
    "unassign": "Aus Projekt entfernen",
    "unassign_confirm": "Freigabe aushängen und aus Projekt entfernen? (Definition bleibt erhalten)",
    "create_title": "Neue SMB-Freigabe anlegen",
    "create_submit": "Anlegen",
    "f_name": "Name (z.B. nas-backup)",
    "f_host": "Host / IP (z.B. 192.168.178.219)",
    "f_share": "Freigabe (z.B. backups)",
    "f_subpath": "Unterpfad (optional)",
    "f_credential": "Credential-Name (optional, leer = Gast)",
    "f_readonly": "Nur lesen",
    "credential_hint": "Login über ein 'basic'-Credential (Benutzer:Passwort) unter /credentials. Leer = Gast-Zugang."
  }
}
